<!-- 视频信息组件 -->
<template>
    <div class="pageContent">
        <CommonRow :title="$t('page.videoInfo.videoImage')">
            <CommonImageCard :src="handleImage(videoInfo.image)" :height="'200px'" />
            <div class="videoTopBox">
                <CommonCard :title="$t('page.videoInfo.videoName')" :content="`${videoInfo.name || '-'}`"
                    :icon="'icon-mingcheng'" />
                <CommonCard :title="$t('page.videoInfo.cameraName')" :content="`${videoInfo.cameraName || '-'}`"
                    :icon="'icon-shexiangtou'" />
                <CommonCard :title="$t('page.videoInfo.videoStartTime')" :content="`${videoInfo.startTime || '-'}`"
                    :icon="'icon-shijian'" />
                <CommonCard :title="$t('page.videoInfo.cropName')" :content="`${info.name || '-'}`"
                    :icon="'icon-zhongzhizuowu'" />
                <!-- <CommonCard :title="$t('page.videoInfo.shootNum')" :content="`${videoInfo.number || 0}`"
                    :icon="'icon-shuliang'" />
                <CommonCard :title="$t('page.videoInfo.videoType')" :content="`${videoInfo.format || '-'}`"
                    :icon="'icon-geshi'" /> -->
                <CommonCard :title="$t('page.videoInfo.shootNum')" :content="`1`"
                    :icon="'icon-shuliang'" />
                <CommonCard :title="$t('page.videoInfo.videoType')" :content="`GIF`"
                    :icon="'icon-geshi'" />
            </div>
        </CommonRow>
        <CommonRow :title="$t('page.videoInfo.videoRemark')">
            <div class="whiteCard">
                <div class="whiteCardText">{{ videoInfo.remark || "-" }}</div>
            </div>
        </CommonRow>
        <CommonRow :title="$t('page.videoInfo.isOverVideo')">
            <template v-if="videoList && videoList.length > 0">
                <div class="parkImgBox">
                    <CommonImageCard v-for="(item, index) in videoList" :key="index" :src="handleImage(item)"
                        :width="'178px'" :height="'118px'" />
                </div>
            </template>
            <template v-else>
                <CommonEmpty :description="$t('empty.noOverVideo')" />
            </template>
        </CommonRow>
    </div>
</template>

<script>
import CommonImageCard from '../common/commonImageCard.vue';
import CommonCard from '../common/commonCard.vue';
import { CODE_SUCCESS } from '../../utils/constant.js';
import { validateImageUrl } from '../../utils/index';
export default {
    components: {
        CommonImageCard,
        CommonCard,
    },
    props: {
        info: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            videoInfo: {}, // 视频信息数据
            videoList: [], // 视频列表
        };
    },
    methods: {
        async refresh() {
            if (!this.info.gifId) {
                this.videoInfo = {};
                return
            }
            this.$toast.loading({
                message: this.$t("common.loading"),
                forbidClick: true,
            });
            try {
                const params = {
                    id: this.info.gifId
                }
                const res = await this.$api.fetchFarmGifsById(params);
                this.$toast.clear()
                if (res.code != CODE_SUCCESS) {
                    this.$toast.fail(res.msg);
                } else {
                    this.videoInfo = res.data || {};
                    if (this.videoInfo.video) {
                        this.videoList = this.videoInfo.video.split(',').map(item => validateImageUrl(item.trim()) ? item.trim() : '');
                    }
                }
            } catch (error) {
                this.$toast.clear()
                console.error("错误", error);
            }
        },
        handleImage(image) {
            return validateImageUrl(image);
        },
    },
};
</script>

<style scoped>
.videoTopBox {
    width: 100%;
    height: auto;
    margin-top: 15px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    column-gap: 30px;
    row-gap: 15px;
}
</style>